import React, { useRef } from "react";
import { Button, Box, CircularProgress } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel } from "@mui/material";

const CompanyEmployeeAddModal = (props) => {
	
	const firstname = useRef(null);
	const lastname = useRef(null);
	const email = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		const employee = {
			firstname: firstname.current.value,
			lastname: lastname.current.value,
			email: email.current.value
		};
		props.onSubmit(employee);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Add Company Employee
			</DialogTitle>
			<DialogContent>
				{ props.loading &&
					<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
						<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
					</Box>
				}
				{ !props.loading &&
					<form onSubmit={handleSubmitForm} autoComplete="off">
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="firstname">Firstname</InputLabel>
							<Input
								inputRef={firstname}
								id="firstname"
								type="firstname"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="lastname">Lastname</InputLabel>
							<Input
								inputRef={lastname}
								id="lastname"
								type="lastname"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="email">Email</InputLabel>
							<Input
								inputRef={email}
								id="new_email"
								type="email"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
					</form>
				}
			</DialogContent>
			{ !props.loading &&
				<DialogActions>
					<Button onClick={handleCancel}>Cancel</Button>
					<Button onClick={handleSubmit} autoFocus>Submit</Button>
				</DialogActions>
			}
		</Dialog>
	);
};

export default CompanyEmployeeAddModal;